import { render, staticRenderFns } from "./Token2.vue?vue&type=template&id=b9d69b68&"
import script from "./Token2.vue?vue&type=script&lang=js&"
export * from "./Token2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports